import React from "react";

const SendBtn = ({ submitForm, disabled, children }) => {
  return (
    <button
      disabled={disabled}
      className={
        "font-semibold w-full cursor-pointer text-white text-sm !leading-[37px] py-3 bg-greenGra lg:text-xs xl:text-sm " +
        (disabled ? "disabled opacity-70" : "")
      }
      onClick={(e) => submitForm()}
    >
      {children}
    </button>
  );
};

export default SendBtn;
